var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  var bindingsFromString = function(bindingString) {
    try {
      var result = parseV2Format();
      if(typeof result === 'object'){
        return result;
      }
      return parseV1Format();
    }
    catch (ex) {
      return parseV1Format();
    }

    function parseV1Format() {
      return bindingString.split("|").map(function(b){
        var bindingParts = b.split("/");
        var bindingInfo = bindingParts[1].split(":");
        var enabled = bindingParts.length >= 4 ? (bindingParts[3] === "True") : true;
        var requireSni = bindingParts.length >= 5 ? (bindingParts[4] === "True"): false;
        return {
          protocol: bindingParts[0],
          enabled: enabled,
          thumbprint: bindingParts[2],
          ipAddress: bindingInfo[0],
          port: bindingInfo[1],
          host: bindingInfo[2],
          requireSni: requireSni
        };
      });
    }

    function parseV2Format() {
      return JSON.parse(bindingString);
    }
  };

  var bindingsToString = function(bindings) {
    var result = bindings.map(function(b) {
      var isHttp = (b.protocol === "http");
      //strip http etc except inside #{...} variable declarations
      b.host = b.host
        .split(/(#{.*?})/g)
        .map(function(h){
           return /^#{.*}$/.test(h)
            ? h
            : h.replace("//", "").replace("/", "").replace("https:", "").replace("http:", "");
        })
        .join("");

      return {
        protocol: b.protocol,
        ipAddress:  b.ipAddress,
        port: b.port,
        host: b.host,
        thumbprint: isHttp ? null : b.thumbprint,
        certificateVariable: isHttp ? null : b.certificateVariable,
        requireSni: isHttp ? false : b.requireSni,
        enabled: b.enabled
      };
    });

    return JSON.stringify(result);
  };

  pluginRegistry.registerFeature("Octopus.Features.IISWebSite", function(busy, octopusRepository, $uibModal, $rootScope, sensitiveValue) {
    return {
      title: "IIS web site and application pool",
      description: "Creates or reconfigures an IIS website and application pool (requires IIS7+)",
      editTemplateUrl: "areas/projects/features/Octopus.Features.IISWebSite_edit.html",
      priority: 8,
      editLink: function($scope, element, action, step, project) {

        if (!action.Properties["Octopus.Action.IISWebSite.DeploymentType"]) {
          action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
        }

        var hasPhysicalPath = action.Properties["Octopus.Action.IISWebSite.WebRoot"] ||
            action.Properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] ||
            action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"];

        if (!action.Properties["Octopus.Action.IISWebSite.WebRootType"] && hasPhysicalPath) {
            action.Properties["Octopus.Action.IISWebSite.WebRootType"] = 'relativeToPackageRoot';
        }
        else if (action.Properties["Octopus.Action.IISWebSite.WebRootType"] && !hasPhysicalPath) {
            action.Properties["Octopus.Action.IISWebSite.WebRootType"] = 'packageRoot';
        }

        if (!action.Properties["Octopus.Action.IISWebSite.StartApplicationPool"]) {
          action.Properties["Octopus.Action.IISWebSite.StartApplicationPool"] = "True";
        }

        if(action.Properties["Octopus.Action.IISWebSite.DeploymentType"] === "webSite") {
          if(isPropTrue(action, "Octopus.Action.IISWebSite.StartApplicationPool") && isPropTrue(action, "Octopus.Action.IISWebSite.StartWebSite")) {
            $scope.iisStartMode = "both";
          } else if(isPropTrue(action, "Octopus.Action.IISWebSite.StartApplicationPool")) {
            $scope.iisStartMode = "appPool";
          } else {
            $scope.iisStartMode = "none";
          }
        }

        function isPropTrue(action, name) {
          if(action.Properties[name]) {
            return action.Properties[name] === "True";
          }

          return true;
        }

        $scope.isIISStep = action.ActionType === "Octopus.IIS";

        $scope.$watch("action.Properties.Octopus.Action.IISWebSite.Bindings", function() {
          $scope.iisBindings = bindingsFromString(action.Properties["Octopus.Action.IISWebSite.Bindings"]);
        });

        $scope.removeBinding = function(b) {
          $scope.iisBindings.splice($scope.iisBindings.indexOf(b), 1);
          action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
        };

        $scope.editBinding = function(binding) {
          $uibModal.open({
            size: "lg",
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
            controller: "IISWebSiteDialogController",
            resolve: {
              "project" : function() {
                return project;
              },
              "binding": function () {
                return _.clone(binding);
              },
               "localNames": function(){
                return $scope.localNames;
               }
            }
          }).result.then(function(result) {
            if (result) {
              var ix = $scope.iisBindings.indexOf(binding);
              $scope.iisBindings[ix] = result;
              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
            }
          });
        };

        $scope.addBinding = function() {
          $uibModal.open({
            size: "lg",
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
            controller: "IISWebSiteDialogController",
            resolve: {
              "project" : function() {
                return project;
              },
              "binding": function() {
                return {
                  protocol: "http",
                  port: "80",
                  ipAddress: "*",
                  host: "",
                  thumbprint: null,
                  enabled: true,
                  requireSni: false
                };
              },
              "localNames": function(){
                return $scope.localNames;
               }
            }
          }).result.then(function(result) {
            if (result) {
              $scope.iisBindings.push(result);
              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
            }
          });
        };

        $scope.selectVirtualDirectory = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'True';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
        };

        $scope.selectWebSite = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'True';
        };

        $scope.selectWebApplication = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'True';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
        };

        $scope.checkWebSiteName = function() {
          var name = action.Properties["Octopus.Action.IISWebSite.WebSiteName"];
          $scope.looksLikeVDir = name && (name.indexOf('/') !== -1 || name.indexOf('\\') !== -1);
        };

        $scope.checkWebRoot = function(variableName) {
          var path = action.Properties[variableName];
          $scope.looksLikeFullPath = path && path.indexOf(':') !== -1;
        };

        $scope.resetPhysicalPath = function (variableName) {
          action.Properties[variableName] = '';
          $scope.looksLikeFullPath = false;
        };

        $scope.updateStartMode = function(startAppPool, startWebSite) {
          action.Properties["Octopus.Action.IISWebSite.StartApplicationPool"] = startAppPool ? "True" : "False";
          action.Properties["Octopus.Action.IISWebSite.StartWebSite"] = startWebSite ? "True" : "False";
        };
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
        action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True";

        action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString([{ protocol: "http", port: 80, host: "", enabled: true }]);
        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite");

        action.Properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = "False";
        action.Properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = "False";
        action.Properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = "True";

        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite.WebApplication");

        function setupApplicationPoolDefaults(action, pathToRootProperty) {
          action.Properties[pathToRootProperty + ".ApplicationPoolFrameworkVersion"] = "v4.0";
          action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] = "ApplicationPoolIdentity";
        }
      },
      preSave: function(action, step) {
        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite");
        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite.WebApplication");

        function normalizeApplicationPoolData(action, pathToRootProperty) {
          if(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] !== "SpecificUser" && !$rootScope.isBound(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"])) {
            action.Properties[pathToRootProperty + ".ApplicationPoolUsername"] = null;
            action.Properties[pathToRootProperty + ".ApplicationPoolPassword"]  = null;
          }
        }
      },
      disable: function(action, step) {
        Object.keys(action.Properties).filter(function(name) {
          return name.indexOf("Octopus.Action.IISWebSite.") === 0;
        }).forEach(function(name){
          delete action.Properties[name];
        });
      }
    };
  });
});

module.controller('IISWebSiteDialogController', function ($scope, busy, octopusRepository, pluginRegistry, $uibModalInstance,
    project, binding, localNames) {
  $scope.isSaving = busy.create();

  $scope.localNames = localNames;
  $scope.binding = binding;
  binding.projectId = project.Id;

  $scope.project = project;

  $scope.certificateMode = {
    managedByOctopus: false
  };

  $scope.resetValues = {
    certificateVariable: $scope.binding.certificateVariable
  };

  $scope.projectVariablesUnavailable = function() {
    return (!$scope.project || !$scope.project.Id);
  };

  function setCertificateManagedByOctopus() {
      $scope.certificateMode.managedByOctopus = !!$scope.binding.certificateVariable;
  }

  setCertificateManagedByOctopus();

  $scope.protocolChanged = function() {
    if ($scope.binding.protocol === "https") {
      $scope.binding.port = "443";
    }
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    if ($scope.binding.protocol === 'https') {
      if (!$scope.certificateMode.managedByOctopus) {
        if (!$scope.binding.thumbprint || $scope.binding.thumbprint.trim() === '')
        {
          $scope.isSaving.showError('An SSL certificate thumbprint must be provided for HTTPS bindings.');
          return;
        }

        if (!$scope.isBound($scope.binding.thumbprint)) {
          $scope.binding.thumbprint = $scope.binding.thumbprint.replace(/[^0-9A-z]/g, '');
        }
      }
    }

    $uibModalInstance.close($scope.binding);
  };

  $scope.$watch(function(scope){ return scope.certificateMode.managedByOctopus;}, function(newValue){
    if (!newValue) {
      $scope.binding.certificateVariable = null;
    } else {
     $scope.binding.thumbprint = null;
    }
  });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.IISWebSite.js
// module id = 5027915536075213
// module chunks = 1